export default "__VITE_ASSET__IpTkuSQW__"